module.exports = __webpack_public_path__ + "public/images/partners/sup-9.61dcb4dc71df27d46adf60db2fe1c410.png";